<template>
  <div>
    <poll-replies :pollId="pollId"></poll-replies>
  </div>
</template>

<script>
import pollReplies from "../polls/components/poll_replies.vue";
import adminApi from "@/api/admin";
import { ref } from "@vue/composition-api";

export default {
  components: {
    pollReplies,
  },
  props: ["pollId"],
};
</script>

<style>
</style>